import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { UsersComponent } from './users.component';
import { RouterModule, Routes } from "@angular/router";
import { InputModule } from "@airnauts/ng-components/input";
import { ReactiveFormsModule } from "@angular/forms";
import { SwitchButtonModule } from "@airnauts/ng-components/switch-button";
import { CustomTableModule } from 'src/app/shared/components/custom-table/custom-table.module';
import { ButtonModule } from '@airnauts/ng-components/button';
import { SelectModule } from '@airnauts/ng-components/select';
import { SelectModule as MySelectModule } from 'src/app/shared/components/select/select.module';
import { DateSortingSelectModule } from "@/shared/components/date-sorting-select/date-sorting-select.module";
import { CustomSectionModule } from "@/shared/components/custom-section/custom-section.module";
import { ImageModule } from "@/shared/components/image/image.module";
import { ElementPreviewModule } from "@/shared/components/element-preview/element-preview.module";
import { CustomDatePickerModule } from "@/shared/components/custom-date-picker/custom-date-picker.module";
import { FeaturedClusterModule } from "@/shared/pipes/featured-cluster/featured-cluster.module";
import { FeaturedElementModule } from "@/shared/pipes/featured-element/featured-element.module";
import { EditUserModalComponent } from "@/modules/users/components/user-details-modal/components/edit-user-modal/edit-user-modal.component";
import { UserClustersComponent } from "@/modules/users/components/user-details-modal/components/user-clusters/user-clusters.component";
import { UserElementsComponent } from "@/modules/users/components/user-details-modal/components/user-elements/user-elements.component";
import { UserDetailsModalComponent } from "@/modules/users/components/user-details-modal/user-details-modal.component";
import { CommonModule } from "@angular/common";
import { UsernameSortingSelectComponent } from './components/username-sorting-select/username-sorting-select.component';
import { TableModule } from '@/shared/components/table/table.module';
import { SectionModule } from "@/shared/components/section/section.module";
import {
  UserSummaryComponent,
} from "@/modules/users/components/user-details-modal/components/user-summary/user-summary.component";
import { ExpandablePanelModule } from "@/shared/components/accordion/expandable-panel.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { TrimTextModule } from "@/shared/pipes/trim-text/trim-text.module";

@NgModule({
  declarations: [
    UsersComponent,
    EditUserModalComponent,
    UserClustersComponent,
    UserElementsComponent,
    UserDetailsModalComponent,
    UsernameSortingSelectComponent,
    UserSummaryComponent,
  ],
  imports: [
    InputModule,
    ButtonModule,
    CustomTableModule,
    SwitchButtonModule,
    ReactiveFormsModule,
    SectionModule,
    SelectModule,
    MySelectModule,
    DateSortingSelectModule,
    CustomSectionModule,
    ImageModule,
    ElementPreviewModule,
    CustomDatePickerModule,
    FeaturedClusterModule,
    FeaturedElementModule,
    CommonModule,
    MatTableModule,
    TableModule,
    SectionModule,
    ExpandablePanelModule,
    MatIconModule,
    MatDialogModule,
    ClipboardModule,
    TrimTextModule,
  ],
})
export class UsersModule { }
